module.exports = __webpack_public_path__ + "static/img/1_15_1.71f10de2.jpg";